import { render } from "./GameThree.vue?vue&type=template&id=9e1b1f46"
import script from "./GameThree.vue?vue&type=script&lang=js"
export * from "./GameThree.vue?vue&type=script&lang=js"

import "./GameThree.vue?vue&type=style&index=0&id=9e1b1f46&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__